import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { SidebarComponent, MenuItem } from '../sidebar/sidebar.component';
import { ToastContainerComponent } from '../toast/toast-container.component';
import { ConfirmDialogContainerComponent } from '../confirm-dialog/confirm-dialog-container.component';

@Component({
  selector: 'lib-layout',
  standalone: true,
  imports: [CommonModule, RouterModule, HeaderComponent, SidebarComponent, ToastContainerComponent, ConfirmDialogContainerComponent],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
})
export class LayoutComponent {
  @Input() menuItems: MenuItem[] = [];
  isSidebarCollapsed = false;

  toggleSidebar(): void {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }
}

